import { VITE_FORGE_URL } from '@constants';
import * as Sentry from '@sentry/react';
import { FrameChat } from 'dragonmouse-shared/interfaces';
import { resolveOptimisticallyUpdatedFrameChats, updateActiveFrameChat } from '../redux/db/actions';
import store from '../redux/store';
import { PollingStream } from './PollingStream';

export class FrameChatPollingStream extends PollingStream<FrameChat> {
	constructor(frameChatId: string) {
		const url = VITE_FORGE_URL + `/poll/frame-chat/${frameChatId}`;

		const onError = (error: Error) => {
			if (error.message === 'Access denied') {
				store.dispatch(updateActiveFrameChat(null));
			} else {
				console.error(error);
			}
		};

		super(url, onError, 'activeScene.frameChat');
	}

	extractData(response: any): FrameChat[] {
		if (response?.frameChat === null || response?.frameChat === undefined) {
			return [];
		}
		return [response.frameChat];
	}

	onData(frameChats: FrameChat[]) {
		const frameChat = frameChats.length > 0 ? frameChats[0] : null;
		if (!frameChat) {
			store.dispatch(updateActiveFrameChat(null));
			return;
		}

		const writeId = frameChat.writeId;
		if (writeId) {
			store.dispatch(resolveOptimisticallyUpdatedFrameChats([writeId]));
		}

		const processedFrameChat: FrameChat = {
			...frameChat,
			createdAt: new Date(frameChat.createdAt),
			updatedAt: new Date(frameChat.updatedAt),
		};

		store.dispatch(updateActiveFrameChat(processedFrameChat));

		// Check for unresolved optimistic writes
		const resolvedWriteIds = new Set(writeId ? [writeId] : []);
		const state = store.getState();
		const unresolvedWrites = state.db.optimisticFrameChatWrites
			.filter((write) => write.value.id === frameChat.id)
			.filter((write) => !resolvedWriteIds.has(write.id));

		if (unresolvedWrites.length > 0) {
			const now = Date.now();
			unresolvedWrites.forEach((write) => {
				if (write.value.createdAt instanceof Date) {
					const age = now - write.value.createdAt.getTime();
					if (age > 2500) {
						const message =
							`[PollingStream] Optimistic ${write.operation} for frameChat ${write.value.id} ` +
							`not resolved after ${age}ms (writeId: ${write.id})`;
						console.warn(message);
						Sentry.captureMessage(message, 'warning');
					}
				}
			});
		}
	}
}
